import React, { useState, useCallback, memo } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from 'ui-components/components/button';
import { defineMessages, FormattedMessage } from 'react-intl';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalFrameworkMethodsPropType } from 'ui-components/prop-types/modal-framework-methods';
import { emptyArray } from 'ui-components/default-props/empty';

import { DateService } from '../../../services/date-service';
import * as ReturnsActions from '../../../store/returns/returns.actions';
import { CalendarDatePicker } from 'ui-components/components/calendar-date-pickers/calendar-date-picker';
import style from './set-received-date-modal.module.less';

const messages = defineMessages({
  markAsReceived: {
    description: 'setReceivedDateModal.markAsReceived',
    defaultMessage: 'Mark as Received',
    id: 't9C+4Y',
  },
  updateReceivedDate: {
    description: 'setReceivedDateModal.updateReceivedDate',
    defaultMessage: 'Update Received Date',
    id: 'QoH9nf',
  },
});

const SetReceivedDateModalComponent = ({ modalFrameworkMethods, modalType, selectedReturns = emptyArray, isFromGrid = false }) => {
  const dispatch = useDispatch();
  const modalMessage = modalType === 'updateReceivedDate' ? messages.updateReceivedDate : messages.markAsReceived;
  const currentDate = DateService.getFormattedCurrentDateTime();

  const [selectedDate, setSelectedDate] = useState(currentDate);
  const { closeModal } = modalFrameworkMethods;

  const setDate = useCallback(() => {
    dispatch(ReturnsActions.markAsReceivedRequest(selectedReturns, selectedDate, isFromGrid));
    closeModal();
  }, [dispatch, selectedReturns, selectedDate, isFromGrid, closeModal]);

  return (
    <Modal className={style['set-received-modal']}>
      <ModalHeader closeModal={closeModal}>
        <FormattedMessage {...modalMessage} />
      </ModalHeader>
      <ModalBody className={style['modal-body']}>
        <div className={style['explanatory-message']}>
          <FormattedMessage defaultMessage='When was this received?' description='setReceivedDateModal.explanatoryMessage' id='+zwCSx' />
        </div>
        <CalendarDatePicker allowPastDates keepOpenOnDateSelect onChange={setSelectedDate} shouldAlwaysBeVisible value={selectedDate} />
      </ModalBody>
      <ModalFooter className={style['modal-footer']}>
        <Button onClick={closeModal} theme='tertiary'>
          <FormattedMessage defaultMessage='Cancel' description='setReceivedDateModal.cancel' id='Pz9YPv' />
        </Button>
        <Button onClick={setDate} theme='primary'>
          <FormattedMessage {...modalMessage} />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

SetReceivedDateModalComponent.propTypes = {
  modalType: PropTypes.string.isRequired,
  modalFrameworkMethods: ModalFrameworkMethodsPropType.isRequired,
  selectedReturns: PropTypes.array,
  isFromGrid: PropTypes.bool,
};

export const SetReceivedDateModal = memo(SetReceivedDateModalComponent);
